import { MrbBaseRouteStore } from "mrb/core";
import { ProducerUserAccountService } from "common/services";

class ProducerPreviewRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
        this.producerUserAccountService = rootStore.createApplicationService(ProducerUserAccountService);
    }

    async getProducers() {
        const response = await this.producerUserAccountService.getProducers();
        return response.data;
    }
}

export default ProducerPreviewRouteStore;
